import { mutatorAction } from "satcheljs";
import { getStore } from "../store/store";

const markHasInitializedMutator: () => void = mutatorAction("markHasInitialized", (): void => {
    getStore().hasInitialized = true;
});
export default markHasInitializedMutator;
